<div class="container-fluid mt-3 ">
    @for (s of InterventionDayListModel; track s) {
    <div class="col-12 col-md-4 col-xl-2 m-1" style="height: 50px;">
        <div class="card h-100 my-1">
            <div class="card-body p-0">
                <!-- <h5 class="card-title">{{s.Portfolio.SamplingPoint.Code}}</h5> -->
                <div class="row h-100 g-0 align-items-stretch ">
                    <span style="width: 10px;" [style.background-color]="getColorByDay(s.Date)"></span>
                    <span class="ms-3 col d-flex align-items-center">{{s.Date.toLocaleString(undefined, {weekday: 'long', day: 'numeric', month: 'numeric' })}}</span>
                    <span class="col-2 d-flex align-items-center text-center">{{s.NumberOfInterventions}}</span>
                    <span class="col-2 d-flex align-items-center text-center">{{s.NumberOfMesures}}</span>
                </div>
            </div>
        </div>
    </div>
    }
</div>